// extracted by mini-css-extract-plugin
module.exports = {"paidAdvertisement":"styles_paidAdvertisement__pmSiP"};